import Vue from 'vue';
import store from 'store';

export default (el) =>
  new Vue({
    components: {
      'search-bar': () => import('./search-bar.vue'),
    },
    el,
    store,
  });
